import * as $ from 'jquery';
import './jquery.unveil';
import './navbar';
import './photos';
import './upload';
import './carousel';
import './albums';


window.controller = $('body').data('controller');
window.controllers = {
    HOME: 'App\\Http\\Controllers\\HomeController@index'
};

let footerheight;

window.getDocHeight = function() {
    if(!footerheight){
        footerheight = $('footer').height();
    }
    let D = document;
    return Math.max(
        D.body.scrollHeight, D.documentElement.scrollHeight,
        D.body.offsetHeight, D.documentElement.offsetHeight,
        D.body.clientHeight, D.documentElement.clientHeight
    ) - footerheight;
}

window.didHitBottom = function(threshold){
    threshold = threshold || 0;
    return (threshold + $(window).scrollTop() + $(window).height() >= getDocHeight());
}

window.isBreakPoint = function (bp) {
    let bps = [320, 480, 768, 1024],
        w = $(window).width(),
        min, max;
    for (let i = 0, l = bps.length; i < l; i++) {
        if (bps[i] === bp) {
            min = bps[i - 1] || 0
            max = bps[i]
            break
        }
    }
    return w > min && w <= max
};

window.setUrlParam = function(names, clears, hash){
    let path = window.location.href;

    path = path.split('#', 2);
    let hasher = "";
    if(path[1]){
        hasher = "#" + path[1];
    }
    path = path[0];

    let vars = path.split('?', 2);

    for(let name in names){
        let val = encodeURIComponent(names[name]);

        if(vars[1] && vars[1].length > 1){
            if(path.search(name+'=') === -1){
                let morethanone = '&';
                if(vars[1].length < 2){
                    morethanone = '';
                }

                path += morethanone+name+'='+val;
                vars = path.split('?', 2);
            }
            else{
                let alls = vars[1].split('&');
                for(let i=0; i<alls.length; i++){
                    let mine = alls[i].trim();
                    if(mine.indexOf(name+'=') == 0){
                        alls[i] = name+'='+val;
                        break;
                    }
                }
                vars[1] = alls.join('&');
                path = vars[0]+'?'+vars[1];
            }
        }
        else if(path.indexOf('?') != -1){
            path += "&"+name+'='+val;
        }
        else{
            path += "?"+name+'='+val;
        }
    }

    if(clears){
        let alls = vars[1].split('&');
        let finals = [];
        for(let i=0; i<alls.length; i++){
            let keep = true;
            for(let j=0; j<clears.length; j++){
                if(alls[i].indexOf(clears[j]) === 0){
                    keep = false;
                    break;
                }
            }
            if(keep){
                finals.push(alls[i]);
            }
        }
        path = vars[0]+'?'+finals.join('&');
    }

    return path + (hash === false ? '' : hasher);
}


class DropDown{
    constructor(el) {
        this.dd = el;
        this.initEvents();
    }

    initEvents() {
        let obj = this;

        obj.dd.on('click', function(event){
            $(this).toggleClass('active');
            event.stopPropagation();
        });
    }
}


$(function() {

    let dd = new DropDown( $('.wrapper-dropdown') );

    $(document).click(function() {
        // all dropdowns
        $('.wrapper-dropdown').removeClass('active');
    });

});

